import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { backgroundImg } from "src/assets/assetsExport";
import { AREA_GUIDES } from "src/data/areaGuides";

const AreaGuidesHubPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>London Area Guides | Letting Engine</title>
        <meta
          name="description"
          content="Explore London area guides — North, Central, East and West. Neighbourhood highlights, transport links, and rental market insights."
        />
      </Helmet>

      <section className="min-h-[50vh] pt-40 pb-16 w-full relative flex items-center justify-center">
        <img
          src={backgroundImg.london}
          alt=""
          className="absolute inset-0 w-full h-full object-cover pointer-events-none z-0 grayscale"
          aria-hidden
        />
        <div className="absolute inset-0 bg-black/50 z-0" />
        <div className="relative z-10 text-center max-w-4xl px-6">
          <span className="font-manrope text-xs uppercase tracking-wider text-white/80 block mb-2">
            Locations
          </span>
          <h1 className="font-teko leading-none mb-4 tracking-[-2px] text-5xl text-white uppercase">
            Area Guides
          </h1>
          <div className="w-16 h-1.5 bg-brand-yellow mx-auto mb-6" />
          <p className="font-manrope text-base leading-relaxed text-white/90 max-w-2xl mx-auto">
            Neighbourhood profiles across the capital — transport, lifestyle, and
            what to expect when renting in each region.
          </p>
        </div>
      </section>

      <section className="py-20 bg-bg-porcelain">
        <div className="max-w-[1200px] mx-auto px-[5%] grid grid-cols-1 md:grid-cols-2 gap-8">
          {AREA_GUIDES.map((guide) => (
            <Link
              key={guide.slug}
              to={`/guides/areas/${guide.slug}`}
              className="group bg-bg-white border border-solid border-[rgba(0,0,0,0.06)] p-8 transition-all duration-300 hover:border-brand-yellow hover:shadow-soft hover:-translate-y-1"
            >
              <span className="font-manrope text-xs uppercase tracking-wider text-text-slate block mb-2">
                {guide.tagline}
              </span>
              <h2 className="page-section-heading mb-3 group-hover:text-brand-gold transition-colors">
                {guide.title}
              </h2>
              <p className="font-manrope text-sm text-text-slate leading-relaxed mb-4">
                {guide.overview[0]}
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                {guide.highlights.slice(0, 3).map((item) => (
                  <span
                    key={item}
                    className="font-manrope text-xs px-2 py-1 bg-bg-porcelain text-text-slate"
                  >
                    {item}
                  </span>
                ))}
              </div>
              <span className="font-teko text-sm uppercase text-brand-gold group-hover:text-text-obsidian transition-colors">
                Explore guide →
              </span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};

export default AreaGuidesHubPage;
